import React, { useMemo, Fragment } from 'react';
import Overlay from './overlay';
import { Navbar } from '../navbar';
import DraggableObserver from './draggable-observer';
import constants from './constants';
import helpers from './helpers';
import noop from '../utils/noop';

const { DRAGGABLE_BORDER_WIDTH } = constants;

// @ts-ignore TS(2554): Expected 1 arguments, but got 0.
const defaultTopbarHeight = Navbar.getHeight();

// @ts-ignore TS(2322): Type 'null' is not assignable to type 'string'.
function FocalPoint({
  onOverlayClick = noop,
  onOverlayDoubleClick = noop,
  onDrag,
  onDragStart,
  onDragEnd,
  targetElementBounds,
  elementComputedStyles,
  controls,
  children = null,
  // @ts-ignore TS(2322): Type 'null' is not assignable to type 'string'.
  tooltipText = null,
  topbarHeight = defaultTopbarHeight,
}) {
  const borderRadius = useMemo(
    () =>
      helpers.getBorderRadius(
        elementComputedStyles,
        targetElementBounds.width,
        targetElementBounds.height
      ),
    [elementComputedStyles, targetElementBounds]
  );

  return (
    <Fragment>
      <div
        className="ws-focal-point-topbar-overlay"
        style={{ height: topbarHeight }}
        onClick={onOverlayClick}
        onDoubleClick={onOverlayDoubleClick}
      />
      <div className="ws-focal-point">
        {children}
        <Overlay
          onOverLayClick={onOverlayClick}
          // @ts-ignore TS(2322): Type '{ top?: number | undefined; bottom?: number ... Remove this comment to see the full error message
          elementBounds={targetElementBounds}
          borderRadius={borderRadius}
        />
        {controls}
        <DraggableObserver
          // @ts-ignore TS(2322): Type '{ top?: number | undefined; bottom?: number ... Remove this comment to see the full error message
          targetElementBounds={targetElementBounds}
          // @ts-ignore TS(2322): Type 'number' is not assignable to type 'never'.
          borderWidth={DRAGGABLE_BORDER_WIDTH}
          // @ts-ignore TS(2322): Type '{ topLeft: { horizontal: number; vertical: n... Remove this comment to see the full error message
          borderRadius={borderRadius}
          // @ts-ignore TS(2322): Type '(...args: any[]) => any' is not assignable t... Remove this comment to see the full error message
          onChange={onDrag}
          // @ts-ignore TS(2322): Type '(...args: any[]) => any' is not assignable t... Remove this comment to see the full error message
          onAfterChange={onDragEnd}
          // @ts-ignore TS(2322): Type '(...args: any[]) => any' is not assignable t... Remove this comment to see the full error message
          onBeforeChange={onDragStart}
          // @ts-ignore TS(2322): Type '(...args: any[]) => any' is not assignable t... Remove this comment to see the full error message
          onDoubleClick={onOverlayDoubleClick}
          // @ts-ignore TS(2322): Type '(...args: any[]) => any' is not assignable t... Remove this comment to see the full error message
          onOverLayClick={onOverlayClick}
          // @ts-ignore TS(2322): Type 'string' is not assignable to type 'never'.
          tooltipText={tooltipText}
        />
      </div>
    </Fragment>
  );
}

export default FocalPoint;
